module.exports = __webpack_public_path__ + "img/pluto122.fc58e6c5.jpg";